/**
 * ¿Es esta ruta la del iframe de las agencias? Comparación EXACTA (`/embed` o
 * `/embed/...`), no por prefijo: un prefijo también capturaba `/embedded` o
 * `/embeds`, y ahí la web apagaba la analítica y ocultaba su propia página 404.
 */
export const isEmbedPath = (pathname) =>
  pathname === '/embed' || String(pathname || '').startsWith('/embed/');

export const isEmbedLocation = () =>
  typeof window !== 'undefined' && isEmbedPath(window.location.pathname);

/**
 * Página de UN componente suelto, sin clave, que CORE-Front carga en un
 * <iframe> (ver src/pages/PlaybookDemo/ComponentPreview.jsx). También ruta
 * EXACTA (con o sin barra final), nunca por prefijo.
 */
export const COMPONENT_PREVIEW_PATH = '/playbook-demo/component';

export const isComponentPreviewPath = (pathname) =>
  String(pathname || '').replace(/\/+$/, '') === COMPONENT_PREVIEW_PATH;

/**
 * Rutas que viven DENTRO de un <iframe> ajeno (la web de una agencia o
 * CORE-Front): sin Google Analytics, sin la barra del webinar y sin widgets
 * flotantes. `isEmbedPath` sigue siendo solo /embed (p. ej. el utm de
 * PoweredBy y el respaldo de AppErrorBoundary dependen de eso).
 */
export const isFramedPath = (pathname) => isEmbedPath(pathname) || isComponentPreviewPath(pathname);

/**
 * La app de los asistentes (`/app` y `/app/...`): una PWA a pantalla completa con su propio manifest.
 * Sin barra del webinar, sin cursor de marca, sin barra de cookies (no escribe nada no esencial)
 * y sin Google Analytics. Ruta EXACTA o con barra: `/apple` o `/application` no cuentan.
 */
export const isAppPath = (pathname) => pathname === '/app' || String(pathname || '').startsWith('/app/');

export const isAppLocation = () => typeof window !== 'undefined' && isAppPath(window.location.pathname);

export const isFramedLocation = () =>
  typeof window !== 'undefined' && isFramedPath(window.location.pathname);
